import axios from 'axios'
import type { BoxTruckMyDriverCompanyDepositDto } from '@numeo/types-core'
import { getApiBaseUrlWithoutV1 } from '@/setup/SetupAxios'

/** Read one My Drivers row after the server has checked operator access, tenant and Groups scope. */
export const fetchMyDriverCompanyDeposit = async (userId: string, signal?: AbortSignal): Promise<BoxTruckMyDriverCompanyDepositDto> => {
    const response = await axios.get<{ success: true; data: BoxTruckMyDriverCompanyDepositDto }>(
        `/box-truck-loads/my-drivers/${encodeURIComponent(userId)}/company-deposit/v1`,
        { baseURL: getApiBaseUrlWithoutV1(), signal }
    )
    return response.data.data
}
